import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import type { MouseEventHandler, ReactElement, ReactNode } from "react";
import type { HomeDataCardHeaderBaseProps } from "./HomeDataCardHeader";
import HomeDataCardHeader from "./HomeDataCardHeader";
import { StyledCardContainer, StyledCardContent, StyledCardTitle } from "./styles";

export interface HomeDataCardProps extends HomeDataCardHeaderBaseProps {
    automationId: string;
    title: Translatable;
    headerContent?: ReactElement | null;
    children: NonNullable<ReactNode>;
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
}

const HomeDataCard = ({
    automationId,
    headerContent,
    children,
    title,
    onMouseEnter,
    onMouseLeave,
    ...headerProps
}: HomeDataCardProps): ReactElement => {
    return (
        <StyledCardContainer
            data-automation={`home-data-card-${automationId}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <HomeDataCardHeader
                title={
                    <I18n
                        data-automation="title-text"
                        element={StyledCardTitle}
                        translatable={title}
                    />
                }
                {...headerProps}
            >
                {headerContent}
            </HomeDataCardHeader>

            <StyledCardContent>{children}</StyledCardContent>
        </StyledCardContainer>
    );
}

export default HomeDataCard;
